import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { trainerCostsApi } from "./trainerCostsApi";

export const useCourseTrainerCostEntries = (courseId: number) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.TRAINER_COST_ENTRIES(courseId),
    queryFn: () => trainerCostsApi.fetchEntries(courseId),
    placeholderData: keepPreviousData,
  });

  // Trainer costs are part of the course finances (balance chart and finances table), refresh those too.
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.TRAINER_COST_ENTRIES(courseId) });
    queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.COURSE_FINANCES(courseId) });
    queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.COURSE_FINANCES_BY_CATEGORIES(courseId) });
  };

  return { invalidate, isLoading, isFetching, costEntries: data?.data ?? [] };
};
